import FunnelHeader from '@/components/v1/FunnelHeader'
import FunnelLayout from '@/components/v1/FunnelLayout'
import LoaderStep from '@/components/v1/LoaderStep'
import MultiSelectStep from '@/components/v1/MultiSelectStep'
import SingleSelectStep from '@/components/v1/SingleSelectStep'
import StatementStep from '@/components/v1/StatementStep'
import { useNavigate, useNavigationType } from 'react-router-dom'
import {
  FUNNEL_PROGRESS_SECTIONS,
  FUNNEL_STEPS,
  getSectionProgress,
  type FunnelStep,
} from './funnelSteps'

function renderStep(step: FunnelStep) {
  switch (step.type) {
    case 'single':
      return (
        <SingleSelectStep
          answers={step.answers}
          onSelect={step.onSelect}
          subtitleKey={step.subtitleKey}
          titleKey={step.titleKey}
        />
      )
    case 'multi':
      return (
        <MultiSelectStep
          answers={step.answers}
          subtitleKey={step.subtitleKey}
          titleKey={step.titleKey}
        />
      )
    case 'statement':
      return <StatementStep emoji={step.emoji} titleKey={step.titleKey} />
    case 'loader':
      return (
        <LoaderStep durationMs={step.durationMs} titleKey={step.titleKey} />
      )
    default: {
      const exhaustiveCheck: never = step
      throw new Error(`Unhandled step type: ${JSON.stringify(exhaustiveCheck)}`)
    }
  }
}

export default function FunnelStepPage({ step }: { step: FunnelStep }) {
  const navigate = useNavigate()
  const navigationType = useNavigationType()

  const isFirstStep = FUNNEL_STEPS[0] === step
  const canGoBack = !isFirstStep && step.type !== 'loader'

  const enterAnimation =
    navigationType === 'POP'
      ? 'animate-slide-in-left'
      : 'animate-slide-in-right'

  return (
    <FunnelLayout
      header={
        <FunnelHeader
          onBack={canGoBack ? () => navigate(-1) : undefined}
          section={step.section}
          sectionProgress={getSectionProgress(step)}
          sections={FUNNEL_PROGRESS_SECTIONS}
          withLogin={step.type === 'single' && step.withLogin}
        />
      }
    >
      <div className={`flex grow flex-col ${enterAnimation}`} key={step.path}>
        {renderStep(step)}
      </div>
    </FunnelLayout>
  )
}
